import {useCallback, useContext, useEffect, useState} from "react";
import useCountryAxiosInstance from "../../../hooks/useCountryAxiosInstance";
import {NotificationsContext} from "../../../ui-components/Notifications";
import {useIntl} from "react-intl";

export const useTaskStats = (worksiteId) => {

  // hooks
  const intl = useIntl();
  const { push } = useContext(NotificationsContext);
  const countryApiRequest = useCountryAxiosInstance();

  // state
  const [stats, setStats] = useState(null);
  const [counter, setCounter] = useState(0);

  // utilities
  const refreshStats = () => { setCounter((prev) => prev +1); }

  const fetchStats = useCallback(
    async () => {
      setStats(null);
      try {
        const response = await countryApiRequest.get(`/worksites_tasks/stats/${worksiteId}`);
        setStats(response);
      } catch (error) {
        console.error(error)
        push({type: "error", title: intl.formatMessage({ id: "an_error_occurred" })});
      }
    },
    [worksiteId],  // eslint-disable-line react-hooks/exhaustive-deps
  );

  useEffect(() => {
    if (!worksiteId)
      return;

    // noinspection JSIgnoredPromiseFromCall
    fetchStats();
  }, [fetchStats, worksiteId, counter,]);

  return {stats, refreshStats};
}

export default useTaskStats;